import React from 'react';
import type { ReactElement } from 'react';
import styled from 'styled-components';
import trackingAdapter from './tracking/trackingAdapter';
import NewsAndAdsContainer from './components/NewsAndAdsContainer';
import ExploreOthers from './components/ExploreOthers';
import ExploreByProperty from './components/ExploreByProperty';
import ExploreByArea from './components/ExploreByArea';
import Taxonomy from './components/Taxonomy';
import type { ChannelObject, RecentSearchType } from '../../shared/model/tsTypes';
import HomepageSearchArea from './components/HomepageSearchArea';
import RecentSearchesContainer from './components/RecentSearchesContainer';
import { layout } from '../../../styles/_variables';
import { channelsArray } from '../../shared/model/constants/channels';
import { trackChannelTabClick } from './tracking/homepageTealium';
import { PAGE_TYPE_HOME_PAGE } from '../../shared/tracking/tealium/constants';
import ElitePlusCarousel from './components/elitePlusCarousel/ElitePlusCarousel';

const RecentSearchSection = styled.div`
  width: 100%;
  margin: 0 auto;
  ${({ theme }) => theme.layoutBreakpoints.large} {
    max-width: ${layout.maxWidthDesktopWide};
  }
`;

export type HomepageComponentProps = {
  currentChannel: ChannelObject;
  recentSearches: RecentSearchType[];
};

export const HomepageComponent = ({
  currentChannel,
  recentSearches,
}: HomepageComponentProps): ReactElement => {
  const trackRecentSearch = () => {
    trackingAdapter.trackRecentSearchClick({
      channelObject: currentChannel,
      homepageType: PAGE_TYPE_HOME_PAGE,
    });
  };

  return (
    <>
      <div>
        <HomepageSearchArea
          currentChannel={currentChannel}
          heading="The #1 address in commercial property"
          channels={channelsArray}
          onSetChannelTracking={trackChannelTabClick}
        />
        <RecentSearchSection>
          <RecentSearchesContainer
            trackRecentSearchClick={trackRecentSearch}
            recentSearches={recentSearches}
          />
        </RecentSearchSection>
      </div>
      <ElitePlusCarousel />
      <ExploreOthers />
      <ExploreByProperty currentChannel={currentChannel} />
      <ExploreByArea currentChannel={currentChannel} />
      <NewsAndAdsContainer />
      <Taxonomy currentChannel={currentChannel} />
    </>
  );
};

export default HomepageComponent;
